export default __webpack_public_path__ + "static/og-image-default-d84af74a6ee47b1ba532484e9b0df47f.png";